var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5H3.5C2.675 3.5 2.0075 4.175 2.0075 5L2 14C2 14.825 2.675 15.5 3.5 15.5H15.5C16.325 15.5 17 14.825 17 14V5C17 4.175 16.325 3.5 15.5 3.5ZM15.2 6.6875L9.8975 10.0025C9.6575 10.1525 9.3425 10.1525 9.1025 10.0025L3.8 6.6875C3.7248 6.64528 3.65894 6.58825 3.60642 6.51984C3.55389 6.45143 3.5158 6.37308 3.49443 6.28953C3.47307 6.20597 3.46888 6.11895 3.48212 6.03373C3.49536 5.94851 3.52575 5.86686 3.57146 5.79373C3.61717 5.72059 3.67724 5.65749 3.74804 5.60825C3.81885 5.559 3.8989 5.52463 3.98337 5.50722C4.06784 5.48981 4.15496 5.48973 4.23947 5.50696C4.32397 5.5242 4.4041 5.5584 4.475 5.6075L9.5 8.75L14.525 5.6075C14.5959 5.5584 14.676 5.5242 14.7605 5.50696C14.845 5.48973 14.9322 5.48981 15.0166 5.50722C15.1011 5.52463 15.1812 5.559 15.252 5.60825C15.3228 5.65749 15.3828 5.72059 15.4285 5.79373C15.4742 5.86686 15.5046 5.94851 15.5179 6.03373C15.5311 6.11895 15.5269 6.20597 15.5056 6.28953C15.4842 6.37308 15.4461 6.45143 15.3936 6.51984C15.3411 6.58825 15.2752 6.64528 15.2 6.6875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBlack);
export default __webpack_public_path__ + "static/media/email-black.b93d1d7c7a9029229b78b83a01aaf474.svg";
export { ForwardRef as ReactComponent };